import { Component, EventEmitter, Inject, OnInit, Optional, Output } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ApiConstants } from 'src/app/core/constants/api-path.constants';
import { AppConstants } from 'src/app/core/constants/appconstants';
import { ApiService } from 'src/app/core/services/api.service';
import { ServiceExportExcel } from 'src/app/core/services/export.service';
import { ServiceLocalStorage } from 'src/app/core/services/local-storage.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { UploadAplStatusComponent } from '../upload-apl-status/upload-apl-status.component';

@Component({
  selector: 'app-upload-apl',
  templateUrl: './upload-apl.component.html',
  styleUrls: ['./upload-apl.component.scss']
})
export class UploadAplComponent implements OnInit {

  city: any;
  exceldata: any = [];
  mOnFileUploaded = new EventEmitter<any>();
  downloadTemplateBaseLink: string = AppConstants.DOWNLOAD_TEMPLATE_BASE_LINK;
  filename: string = "";
  title: string;

  constructor(
    private dialog: MatDialog,
    private readonly apiService: ApiService,
    private notifyService: NotificationService,
    private ngxLoader: NgxUiLoaderService,
    private serviceLocalStorage: ServiceLocalStorage,
    private serviceExportExcel: ServiceExportExcel,
    public dialogRef: MatDialogRef<UploadAplComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public dataResponse: any
  ) {
    if (dataResponse) {
      this.city = dataResponse;
      const isMetro = this.city === "METRO_SETUP_BATCH";
      this.filename = isMetro ? "MetroUploadTemplate.xlsx" : "ALUPLOADTEMPLATE.xlsx";
      this.title = isMetro ? "Upload Metro" : "Upload AL";
    }
  }

  ngOnInit() { }

  onFileChange($event) {
    const files = $event.target.files;
    if (!files || files.length === 0) return;
    const fileName = files[0].name;
    const fileExt = fileName.split(".").pop();

    if (!fileExt || (!fileExt.includes("xlsx") && !fileExt.includes("xls"))) {
      this.ngxLoader.stop();
      this.notifyService.showError("There seems to be a problem with the file that you uploaded. Please upload a Valid File", null);
      return;
    }

    const type = this.city === "METRO_SETUP_BATCH" ? "METRO_SETUP_BATCH" : "LANDMARK_BATCH";
    let userId: any = parseInt(this.serviceLocalStorage.getUserId().toString());
    const formdata = new FormData();
    formdata.append('file', files[0]);
    formdata.append('type', type);
    formdata.append('userid', userId);
    this.ngxLoader.start();
    this.apiService.doPostFile(
      ApiConstants.upload,
      formdata,
      (success) => {
        this.ngxLoader.stop();
        this.notifyService.showSuccess(`Excel UplodedCount is = ${success.itemsSaved}`, null);
        this.onFileUpload(success);
        this.dialogRef.close();
        this.mOnFileUploaded.emit(true);
      },
      (error) => {
        this.ngxLoader.stop();
        console.log(error);
      }
    );
  }

  onFileUpload(uplodedResult) {
    this.dialog.open(UploadAplStatusComponent, {
      disableClose: true,
      height: "450px",
      width: "550px",
      data: uplodedResult
    });
  }

}
